import React from 'react';
import { FaFilePdf, FaExternalLinkAlt } from 'react-icons/fa';
import { researchPublications } from '../data/researchPublications';

function ResearchCard({ paper }) {
  return (
    <div className="research-card">
      <div className="research-card-header">
        <span className="research-year">{paper.year}</span>
        <div className="research-tags">
          {paper.tags.map(tag => (
            <span key={tag} className="research-tag">{tag}</span>
          ))}
        </div>
      </div>
      <h3 className="research-title">{paper.title}</h3>
      <p className="research-description">{paper.description}</p>
      <div className="research-card-footer">
        <a
          href={paper.pdf}
          target="_blank"
          rel="noreferrer"
          className="research-pdf-link"
        >
          <FaFilePdf /> View PDF <FaExternalLinkAlt className="research-ext-icon" />
        </a>
      </div>
    </div>
  );
}

function Research() {
  return (
    <div className="research-page">
      <section className="research-hero">
        <h1 className="research-page-title">Research</h1>
        {/* <p className="research-page-subtitle">
          Papers, reports, and investigations in embedded systems, IoT, and wireless networks.
          PDFs are linked below — drop new files in <code>/public/research/</code> and update the list.
        </p> */}
      </section>

      <div className="research-grid">
        {researchPublications.map(paper => (
          <ResearchCard key={paper.id} paper={paper} />
        ))}
      </div>
    </div>
  );
}

export default Research;
